import {
    Building2,
    Gavel,
    Banknote,
    Ruler,
    Globe,
    Scale,
    LineChart,
    ArrowRight,
    ThumbsUp,
    Users,
    ShieldCheck,
    Home,
    LandPlot,
} from 'lucide-react';

const Services = () => {
    return (
        <section className="our-service-container-fb">
            <div className="our-service-header-fb">
                <h1 className="our-service-title-fb">Comprehensive Real Estate Services</h1>
                <p className="our-service-subtitle-fb">Tailored solutions for all your property needs</p>
            </div>

            {/* Services Grid */}
            <div className="our-service-grid-fb">
                <div className="our-service-card-fb">
                    <Home className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Buy / Sell Properties</h2>
                    <p className="our-service-card-desc-fb">Expert support for new, resale, and under-construction properties.</p>
                </div>
                <div className="our-service-card-fb">
                    <Building2 className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Rental & Leasing</h2>
                    <p className="our-service-card-desc-fb">Residential and commercial property rental and lease solutions.</p>
                </div>
                <div className="our-service-card-fb">
                    <LandPlot className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Land Dealing</h2>
                    <p className="our-service-card-desc-fb">Land acquisition, investor deals, and agricultural plots.</p>
                </div>
                <div className="our-service-card-fb">
                    <Gavel className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Legal Assistance</h2>
                    <p className="our-service-card-desc-fb">End-to-end help with documentation, registration, and compliance.</p>
                </div>
                <div className="our-service-card-fb">
                    <Banknote className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Loan & Finance</h2>
                    <p className="our-service-card-desc-fb">Assistance with home loans and financial approvals.</p>
                </div>
                <div className="our-service-card-fb">
                    <Ruler className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Vastu & Interior Guidance</h2>
                    <p className="our-service-card-desc-fb">Enhance energy and aesthetics with expert suggestions.</p>
                </div>
                <div className="our-service-card-fb">
                    <Globe className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">NRI Services</h2>
                    <p className="our-service-card-desc-fb">Property management and transactions tailored for NRIs.</p>
                </div>
            </div>

            {/* Benefits Section */}
            <div className="our-service-header-fb">
                <h1 className="our-service-title-fb">Why Choose Us?</h1>
                <p className="our-service-subtitle-fb">The advantages of working with us</p>
            </div>

            <div className="our-service-benefits-grid-fb">
                <div className="our-service-benefit-card-fb">
                    <ThumbsUp className="our-service-benefit-icon-fb" />
                    <h3>Trusted Expertise</h3>
                    <p>Over 5 years of experience in real estate and insurance services.</p>
                </div>
                <div className="our-service-benefit-card-fb">
                    <Users className="our-service-benefit-icon-fb" />
                    <h3>Client-Focused</h3>
                    <p>Personalized attention and transparent guidance every step of the way.</p>
                </div>
                <div className="our-service-benefit-card-fb">
                    <ShieldCheck className="our-service-benefit-icon-fb" />
                    <h3>Secure & Legal</h3>
                    <p>RERA-registered and fully compliant in every transaction.</p>
                </div>
            </div>

            {/* CTA */}
            <div className="our-service-cta-fb">
                <p className="our-service-benefit-fb">
                    Experience real estate redefined—where trust meets results.
                </p>
                <a href="/contact-us" className="our-service-button-fb">
                    Learn More About Our Services <ArrowRight size={18} />
                </a>
            </div>
        </section>
    );
};

export default Services;
